import type { CoresAplicativo } from "../../../services/coresAplicativo"

export type CoresAplicativoModel = CoresAplicativo

// Valores iniciais espelham os defaults da entidade AplicativoDados no backend.
export const CoresAplicativoInicial: CoresAplicativoModel = {
    // Cores do Site
    corSitePrimaria: "#e74a3b",
    corSiteSecundaria: "#FFD300",
    corSiteBarraFinalizar: "#e74a3b",
    corSitePreco: "#E74A3B",
    corSiteBotaoConfirmar: "#28a745",
    // Cores do Aplicativo
    textPesquisaColor: "#e74a3b",
    corCategoriaCardapio: "#FFFFFE",
    corPadrao: "e74a3b",
    corPadraoSecundaria: "",
    corTitulosLabelPadrao: "#000000",
    corSubtitulos: "#e74a3b",
    corBotoesCabecalho: "#A90E00",
    corBotoesRodape: "#FFFFFE",
    corTextoDestaque: "#FFD300",
    corPreco: "#309239",
    corBackground: "#F6F6F6",
    corBackgroundSplash: "#F6F6F6",
    corFundoCardapio: "#F6F6F6",
    corFundoMenuSelecionado: "#FFFFFE",
    corBarraEndereco: "#F2F2F2",
    corFonteBotoes: "#FFFFFE",
    corBackgroundPrimeiroAcesso: "#F6F6F6",
    corCabecalho: "#e74a3b",
    corRodape: "#e74a3b",
    // Cores dos Panfletos
    corFundoPanfleto: "#FFD300",
    podeEditar: true,
}

export type CampoCor = {
    campo: keyof Omit<CoresAplicativoModel, "podeEditar">
    label: string
    descricao?: string
}

export type GrupoCores = {
    titulo: string
    campos: CampoCor[]
}

export const GRUPOS_CORES: GrupoCores[] = [
    {
        titulo: "Cores do Site",
        campos: [
            { campo: "corSitePrimaria", label: "Primária", descricao: "Cores primárias do site." },
            {
                campo: "corSiteSecundaria",
                label: "Secundária",
                descricao: "Cores secundárias do site.",
            },
            {
                campo: "corSiteBarraFinalizar",
                label: "Barra de Finalizar Pedido",
                descricao: "Cor da barra de finalizar pedido do site.",
            },
            {
                campo: "corSitePreco",
                label: "Preço",
                descricao: "Cor dos preços do site.",
            },
            {
                campo: "corSiteBotaoConfirmar",
                label: "Botão Avançar/Finalizar",
                descricao: "Cor do botão Avançar/Finalizar pedido no cardápio digital.",
            },
        ],
    },
    {
        titulo: "Cores do Aplicativo",
        campos: [
            {
                campo: "textPesquisaColor",
                label: "Cardápio / Promoção",
                descricao:
                    "Cardápio: fundo da categoria do cardápio. Promoção: na descrição da promoção.",
            },
            {
                campo: "corPadrao",
                label: "Cor Primária",
                descricao: "Cor dos ícones e botões de ação.",
            },
            {
                campo: "corPadraoSecundaria",
                label: "Cor Secundária",
                descricao: "Cor do botão do selo e fundo do botão já possui cadastro.",
            },
            {
                campo: "corTitulosLabelPadrao",
                label: "Cor Padrão dos Títulos",
                descricao:
                    "Cor dos textos de títulos descritivos e dos campos de entrada de dados.",
            },
            {
                campo: "corSubtitulos",
                label: "Cor Subtítulos",
                descricao: "Cor das descrições exibidas.",
            },
            {
                campo: "corBotoesCabecalho",
                label: "Cor Botões do Cabeçalho",
                descricao: "Cor dos botões do cabeçalho: menu e lupa.",
            },
            {
                campo: "corBotoesRodape",
                label: "Cor Botões do Rodapé",
                descricao: "Cor dos botões na barra de menu do rodapé.",
            },
            {
                campo: "corTextoDestaque",
                label: "Cor de destaque do Texto",
                descricao:
                    "Cor da fonte das mensagens explicativas (login, tela de selos e promoções).",
            },
            { campo: "corPreco", label: "Cor Preço" },
            {
                campo: "corBackground",
                label: "Fundo Aplicativo",
                descricao: "Cor de fundo das telas do aplicativo.",
            },
            {
                campo: "corBackgroundSplash",
                label: "Fundo Abrindo Aplicativo",
                descricao: "Cor de fundo da tela de splash.",
            },
            {
                campo: "corFundoCardapio",
                label: "Fundo do Cardápio",
                descricao: "Cor de fundo do cardápio.",
            },
            {
                campo: "corFundoMenuSelecionado",
                label: "Fundo Menu Selecionado",
                descricao: "Cor de fundo do menu superior selecionado.",
            },
            {
                campo: "corBarraEndereco",
                label: "Fundo Opção Endereço",
                descricao: "Cor de fundo da barra de endereço.",
            },
            {
                campo: "corFonteBotoes",
                label: "Cor Fonte Botões",
                descricao: "Cor da fonte dos botões.",
            },
            {
                campo: "corBackgroundPrimeiroAcesso",
                label: "Fundo Tela Login",
                descricao: "Cor de fundo da tela de primeiro acesso.",
            },
            {
                campo: "corCabecalho",
                label: "Cabeçalho",
                descricao: "Cor de fundo do cabeçalho e topo do menu.",
            },
            {
                campo: "corRodape",
                label: "Rodapé",
                descricao: "Cor de fundo dos botões do rodapé.",
            },
            {
                campo: "corCategoriaCardapio",
                label: "Categoria Cardápio (não está em uso)",
                descricao: "Campo legado mantido para compatibilidade — não está em uso.",
            },
        ],
    },
    {
        titulo: "Cores dos Panfletos",
        campos: [
            {
                campo: "corFundoPanfleto",
                label: "Cor Panfleto",
                descricao: "Cor de fundo do panfleto gerado pelo sistema.",
            },
        ],
    },
]
